export const EMPTY_STRING = '';
export const MIN_SEARCH_LENGTH = 3;
export const SELECTION_LIMIT = 100;
export const DEBOUNCE_DELAY = 300;
export const NOTIFICATION_TIMEOUT = 5000;
export const ONE_DAY_IN_SECONDS = 86400;
export const CLEAR_VALUE = 'clear';
export const TIMEZONES = [
  { label: 'RESET TIME ZONE', value: 'clear' },
  { label: 'Central Time', value: 'America/Chicago' },
  { label: 'Eastern Time', value: 'America/New_York' },
  { label: 'Mountain Time', value: 'America/Denver' },
  { label: 'Pacific Time', value: 'America/Los_Angeles' },
  { label: 'UTC', value: 'UTC' },
];

export const TIMEZONE_OFFSETS: { [key: string]: number } = {
  UTC: 0,
  'America/Chicago': 6, // CST UTC-6
  'America/New_York': 5, // EST UTC-5
  'America/Denver': 7, // MST UTC-7
  'America/Los_Angeles': 8, // PST UTC-8
};
export const STATE_CODE_MAP = {
  1: 'Inactive',
  0: 'Active',
};
export const STATUS_CODE_MAP = {
  1: 'Active',
  2: 'Inactive',
};
export const IOWA_ID = '8e229164-4c97-de11-8de3-0019d18a6560';

export const BREED_CATEGORY = {
  BEEF: 100000000,
  DAIRY: 100000001,
  CROSS: 100000002,
  MEAT: 100000003,
  PETS: 100000004,
  DEER: 100000005,
  EXOTIC: 100000006,
};
export const CONCENTRATION = {
  '2 Million': 100000000,
  '5 Million': 100000001,
  Unknown: 100000002,
  '3 Million': 100000003,
};
export const CSS_CERTIFIED = {
  No: 100000000,
  Yes: 100000001,
};
export const SEX = {
  Female: 1,
  Male: 2,
  Unknown: 3,
};

export const SEX_EMBRYO = {
  Female: 100000000,
  Male: 100000001,
  Unknown: 100000002,
};

export const FRESH_FROZEN = {
  Fresh: 100000000,
  Frozen: 100000001,
};

export const TRANSFER_CLINIC_RANCH_HAULIN = {
  CLINIC: 1,
  RANCH: 2,
  HAUL_IN: 3,
} as const;

export const ENVIRONMENT_ID_VALUES = {
  AUS: 36,
  Brazil: 76,
  USA: 0,
  USA_TRAINING: 9999,
  Crandall: 716,
} as const;

export const EXPORT_VALUES = {
  NON_EU: 'Yes - Non EU',
  WASH: 'WASH',
  EU: 'EU',
  AU: 'AU',
  SA: 'SA',
  UK: 'UK',
} as const;

export const EXPORT_ENUMS = {
  No: 0,
  'Yes - Non EU': 1,
  EU: 2,
  AU: 3,
  UK: 4,
  'SA (South America)': 5,
} as const;

export const EMBRYO_METHOD = {
  ET: 100000000,
  IVF: 100000001,
  Clone: 100000002,
  '.': 100000003,
  LAP: 100000003,
} as const;

export const EMBRYO_METHOD_OPTIONS = [
  { value: 100000000, label: 'ET' },
  { value: 100000001, label: 'IVF' },
  { value: 100000002, label: 'Clone' },
  { value: 100000003, label: '.' },
  { value: 100000004, label: 'LAP' },
];

export const FREEZE_METHODS = {
  GLYCEROL: 'Glycerol',
  VITRIFICATION: 'Vitrification',
  EG_WITH_SUC: '1.5M EG with suc',
  EG: '1.5M EG',
} as const;

export const EMBRYO_POSITION = {
  LEFT: 100000001,
  RIGHT: 100000000,
} as const;

export const MOBILE_MAX_WIDTH = '(max-width: 768px)';

export const DATE_FORMAT = 'MM/dd/yyyy';
export const DATETIME_FORMAT = 'MM/dd/yyyy h:mm a';

export const TRACKING_NUMBER_OPTIONS = [
  { label: 'Client PU', value: 'Client PU' },
  { label: 'Courier', value: 'Courier' },
  { label: 'TOG PU/Delivery', value: 'TOG PU/Delivery' },
  { label: 'Tracking Number', value: 'Tracking Number' },
];

export const shipmentStatusOptions = [
  { label: 'Shipped', value: 100000000 },
  { label: 'Scheduled', value: 100000001 },
  { label: 'In Progress', value: 100000002 },
  { label: 'Transfer Trip', value: 100000003 },
  { label: 'IA In Clinic Frozen', value: 100000004 },
  { label: 'MTO Client Entry', value: 100000005 },
  { label: 'MTO TOG Client Review', value: 100000006 },
  { label: 'Incomplete', value: 100000007 },
];

export const shippingMethodOptions = [
  { label: 'UPS', value: 100000000 },
  { label: 'Fedex', value: 100000001 },
  { label: 'In Customer Pickup', value: 100000002 },
  { label: 'TOG Delivery', value: 100000003 },
  { label: 'Courier', value: 100000004 },
  { label: 'Export', value: 100000005 },
  { label: 'Customer Pickup GAC', value: 100000006 },
  { label: 'Exports-Courier', value: 100000007 },
  { label: 'Discard', value: 100000008 },
];

export const shipmentCategoryOptions = [
  { label: 'TOG', value: 100000000 },
  { label: 'Progentus', value: 100000001 },
  { label: 'Terminal Beef Embryos', value: 100000002 },
];

export const billStatusOptions = [
  { label: 'Do Not Bill', value: 100000000 },
  { label: 'Billed', value: 100000001 },
  { label: 'Pulled', value: 100000002 },
];

export const accountStatusOptions = [
  { label: 'Open Credit', value: 100000000 },
  { label: 'Prepay', value: 100000001 },
  { label: 'Credit Manager Review', value: 100000002 },
  { label: 'Closed - No New Business', value: 100000003 },
  { label: 'Watch Customer', value: 100000004 },
  { label: 'In Collections', value: 100000005 },
];

export const CLINIC_RANCH_HAUL_IN = {
  Clinic: 1,
  Ranch: 2,
  'Haul-In': 3,
};

export const IMPLANT_STATUS = {
  Open: 100000000,
  Pregnant: 100000001,
  Calved: 100000002,
  Implanted: 100000003,
  Aborted: 100000004,
};
